import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { BaseUrlHelperService } from "../helper/baseUrlHelper.service";
import { NbcLoggerService } from "../logger/nbc-logger.service";

@Injectable({
    providedIn: "root",
})
export class TimesheetService {
    constructor(
        private http: HttpClient,
        private _apiroot: BaseUrlHelperService,
        private log: NbcLoggerService
    ) {}

    getTimesheetSummaryQuery(
        currentPage = 1,
        pageSize = 10,
        totalRecords = 10,
        selectedTab?
    ) {
        return {
            businessUnitId: 1,
            timesheetStatus: selectedTab || "InProgress",
            departmentId: 1,
            timesheetName: null,
            currentPage: currentPage || 1,
            pageSize: pageSize || 10,
            totalRecords: totalRecords || 0,
            sortByColumn: "",
            reverseSort: false,
            searchOptionId: null,
            searchTerm: { id: "", description: "" },
            batchid: null,
            isCompleted: false,
            selectedTab: "",
        };
    }

    getTimesheetSummary(query) {
        this.log.trace("timesheetService: Get Timesheet batch summary");
        return this.http
            .post(
                this._apiroot.baseUrl +
                    "talentPayroll/dashboard/timesheetBatch/summary",
                query
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    getTimeCardSummary(query) {
        this.log.trace("timesheetService: Get Timecard batch summary");
        return this.http
            .post(
                this._apiroot.baseUrl + "talentPayroll/timecard/summary",
                query
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    validateName(query) {
        this.log.trace("timesheetService: Validate Timesheet Name");
        return this.http
            .post(
                this._apiroot.baseUrl +
                    "talentPayroll/timesheet/name/validate/",
                query
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    create(copyTimesheetSetting: any): Observable<any> {
        return this.http
            .post<any>(
                this._apiroot.baseUrl +
                    "talentPayroll/timesheetBatch/create/template",
                copyTimesheetSetting
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    delete(query) {
        this.log.trace("timesheetService: create Timesheet batch");
        return this.http
            .post<any>(
                this._apiroot.baseUrl + "talentPayroll/timesheetBatch/delete",
                query
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }
}
